var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyzedOlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 2.5,
    fill: "white",
    stroke: "#858585"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98108 8C8.98108 8.57375 8.8969 9.106 8.72852 9.59675C8.56333 10.0839 8.32824 10.5061 8.02327 10.8633C7.71829 11.2206 7.35137 11.5002 6.9225 11.7023C6.49362 11.9008 6.0171 12 5.49292 12C4.97192 12 4.49699 11.9008 4.06812 11.7023C3.63924 11.5002 3.27073 11.2206 2.96258 10.8633C2.6576 10.5061 2.42093 10.0839 2.25256 9.59675C2.08419 9.106 2 8.57375 2 8C2 7.42625 2.08419 6.8958 2.25256 6.40866C2.42093 5.91791 2.6576 5.49391 2.96258 5.13667C3.27073 4.77943 3.63924 4.50158 4.06812 4.30311C4.49699 4.10104 4.97192 4 5.49292 4C5.84238 4 6.17118 4.04691 6.47933 4.14073C6.78748 4.23094 7.07022 4.36085 7.32754 4.53045C7.58487 4.69644 7.81519 4.90032 8.0185 5.14208C8.225 5.38024 8.39972 5.64727 8.54268 5.94317C8.68564 6.23906 8.79365 6.56022 8.86672 6.90663C8.94296 7.25304 8.98108 7.6175 8.98108 8ZM7.67064 8C7.67064 7.57059 7.61981 7.18629 7.51815 6.84709C7.41649 6.50428 7.27195 6.2138 7.08452 5.97564C6.89708 5.73748 6.66835 5.55525 6.39832 5.42896C6.13147 5.30266 5.82967 5.23951 5.49292 5.23951C5.15618 5.23951 4.85279 5.30266 4.58276 5.42896C4.31591 5.55525 4.08718 5.73748 3.89657 5.97564C3.70913 6.2138 3.56459 6.50428 3.46293 6.84709C3.36127 7.18629 3.31044 7.57059 3.31044 8C3.31044 8.42941 3.36127 8.81552 3.46293 9.15832C3.56459 9.49752 3.70913 9.7862 3.89657 10.0244C4.08718 10.2589 4.31591 10.4393 4.58276 10.5656C4.85279 10.6919 5.15618 10.7551 5.49292 10.7551C5.82967 10.7551 6.13147 10.6919 6.39832 10.5656C6.66835 10.4393 6.89708 10.2589 7.08452 10.0244C7.27195 9.7862 7.41649 9.49752 7.51815 9.15832C7.61981 8.81552 7.67064 8.42941 7.67064 8Z",
    fill: "#858585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.8633V11.9134H9.96384V4.0866H11.2457V10.8633H14Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyzedOlIcon);
export default __webpack_public_path__ + "static/media/AnalyzedOLIcon.311721ebf2d4a8c697edb7a62770e3e3.svg";
export { ForwardRef as ReactComponent };